<script lang="ts">
    import type Monster from "../../lib/monster";
    import { getPathFor } from "../Attributes/util";
    import type { Point } from "../Attributes/util";
    import { convertNormalizedPath, generateFillColor } from "./util";
    export let monster: Monster;
    export let dimensions: number;
    const normalizedRange = 10;

    const generatePath = (sideLength: number): Point[] => {
        const path: Point[] = convertNormalizedPath(
            [
                { x: 0.5, y: 0.5 },
                { x: 0.5, y: 3.5 },
                { x: 6, y: 7 },
                { x: 4.5, y: 8.5 },
                { x: 5, y: 9 },
                { x: 6.5, y: 7.5 },
                { x: 8, y: 9 },
                { x: 9, y: 8 },
                { x: 7.5, y: 6.5 },
                { x: 9, y: 5 },
                { x: 8.5, y: 4.5 },
                { x: 7, y: 6 },
                { x: 3.5, y: 0.5 },
            ],
            sideLength,
            0,
            -3
        );

        return path;
    };
</script>

{#if dimensions}
    <path
        d={getPathFor(generatePath(dimensions))(
            { x: dimensions / 2, y: dimensions / 2 },
            normalizedRange
        )}
        stroke="black"
        fill={generateFillColor('attack', monster)}
    />
{/if}

<style>
</style>
